/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type useClaimStartingCoinsFragment = {
    readonly gamification?: {
        readonly hasClaimedStartingCoins: boolean;
    } | null | undefined;
    readonly " $refType": "useClaimStartingCoinsFragment";
};
export type useClaimStartingCoinsFragment$data = useClaimStartingCoinsFragment;
export type useClaimStartingCoinsFragment$key = {
    readonly " $data"?: useClaimStartingCoinsFragment$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"useClaimStartingCoinsFragment">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "enableShop"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "useClaimStartingCoinsFragment",
  "selections": [
    {
      "condition": "enableShop",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Gamification",
          "kind": "LinkedField",
          "name": "gamification",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hasClaimedStartingCoins",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    }
  ],
  "type": "Student",
  "abstractKey": null
};
(node as any).hash = 'bfeefc92e5e50286d540ca59ebbf66e2';
export default node;
